import { useMutation } from '@tanstack/react-query';

import { PostAddDeliveryEndpointPayload, PostAddDeliveryEndpointResponse } from '@/api/sofarApi/types';
import { axios } from '@/common/axios';
import { MutationConfig, queryClient } from '@/common/react-query';

export const postAddDeliveryEndpoint = (
    payload: PostAddDeliveryEndpointPayload
): Promise<PostAddDeliveryEndpointResponse> => {
    return axios.post('/fetch/add-delivery-endpoint', payload);
};

type UsePostAddDeliveryEndpointOptions = {
    config?: MutationConfig<typeof postAddDeliveryEndpoint>;
    data?: PostAddDeliveryEndpointPayload;
};

export const usePostAddDeliveryEndpoint = ({ config }: UsePostAddDeliveryEndpointOptions = {}) => {
    return useMutation({
        ...config,
        mutationFn: postAddDeliveryEndpoint,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['sofar-api-delivery-endpoints'] }),
    });
};
